enum ImageType {
  Ready = 'ready',
  Success = 'success',
  Welcome = 'welcome',
}

export default ImageType;
